import { render, staticRenderFns } from "./BankSupport.vue?vue&type=template&id=1119cf18&scoped=true"
import script from "./BankSupport.vue?vue&type=script&lang=js"
export * from "./BankSupport.vue?vue&type=script&lang=js"
import style0 from "./BankSupport.vue?vue&type=style&index=0&id=1119cf18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1119cf18",
  null
  
)

export default component.exports